import React from "react";
import { MARQUEE } from "@/lib/brand";

export const Marquee = () => {
  const items = [...MARQUEE, ...MARQUEE];
  return (
    <div
      data-testid="marquee"
      className="relative overflow-hidden border-b border-white/8 bg-[#0b0b0e] py-6"
    >
      <div className="marquee-track">
        {items.map((t, i) => (
          <span key={i} className="flex shrink-0 items-center">
            <span className="px-8 font-display text-xl font-semibold uppercase tracking-[0.12em] text-white/25 sm:text-2xl">
              {t}
            </span>
            <span className="h-1 w-1 rounded-full bg-[hsl(var(--orv-blue))]/70" />
          </span>
        ))}
      </div>
      <div className="pointer-events-none absolute inset-y-0 left-0 w-28 bg-gradient-to-r from-[#0b0b0e] to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-28 bg-gradient-to-l from-[#0b0b0e] to-transparent" />
    </div>
  );
};
